export class Login {
  username: string = '';
  password: string = '';
  rememberMe: boolean = false;
  RoleId: number | undefined;
  authToken: string | undefined;
}

export class UserSession {
  Id: number;
  UserId: number;
  UserSessionStartdatetime: string;
  UserSessionEnddatetime: string;
  AspNetUsersId: string;
}
